import _taggedTemplateLiteral from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3;

import styled from '@xstyled/styled-components';
import { Typography } from 'antd';
import { Heading4 } from '@lib/common';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var Paragraph = Typography.Paragraph;
var Container = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  width: 100%;\n  height: 100%;\n"])));
var Title = styled(Heading4)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral([""])));
var Content = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  width: 700px;\n  min-height: 100px;\n  text-align: center;\n"])));
export var EmptySubmissionPlaceholder = function EmptySubmissionPlaceholder(props) {
  var label = props.label;
  return /*#__PURE__*/_jsx(Container, {
    children: /*#__PURE__*/_jsxs(Content, {
      children: [/*#__PURE__*/_jsx(Title, {
        children: label.title
      }), /*#__PURE__*/_jsx(Paragraph, {
        children: label.description
      })]
    })
  });
};